import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
 
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID ?? ''}`,
    redirectUri:
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_REDIRECT_URL_PRODUCTION
        : process.env.REACT_APP_REDIRECT_URL_DEVELOPMENT,
    postLogoutRedirectUri:
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_REDIRECT_URL_PRODUCTION
        : process.env.REACT_APP_REDIRECT_URL_DEVELOPMENT,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.log(message);
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const loginRequest = {
  scopes: [
    'User.Read', 
    'https://analysis.windows.net/powerbi/api/.default'
  ],
};
